<template>
  <main>
    <PageIntro
      :heading="'Your <span>My Latics</span> account'"
      :body="'<p>Reset your password with the code provided.</p>'" />
    <ResetPasswordForm />
    <FooterShout :type="'signin'"/>
  </main>
</template>

<script>
  import ResetPasswordForm from '@/components/ResetPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ResetPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>